module.exports = __webpack_public_path__ + "img/ct.b252ece7.png";